import { MenuItem } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

type AsyncSearchNoOptionsMessageProps = {
  noOptionsMessage: string | React.ReactElement;
};

export const AsyncSearchNoOptionsMessage = ({ noOptionsMessage }: AsyncSearchNoOptionsMessageProps) => (
  <MenuItem style={{ height: `34px`, color: RoutalPalette.text }}>{noOptionsMessage}</MenuItem>
);

type AsyncSearchCustomOptionProps = {
  innerProps: any;
  isDisabled: boolean;
  data: {
    label?: string;
    __isNew__?: boolean;
    icon?: string;
  };
};

export const AsyncSearchCustomOption = ({ innerProps, isDisabled, data }: AsyncSearchCustomOptionProps) => {
  return !isDisabled ? (
    <MenuItem {...innerProps} style={{ height: `34px`, color: RoutalPalette.text }}>
      {data.label}
    </MenuItem>
  ) : null;
};

export default {};
